import clsx from 'clsx';

import EditableField from '~components/generic/editable-field/EditableField/EditableField';
import { ModuleAttachments } from '~components/generic/module-attachments/ModuleAttachments';
import { IEntityComponentProps } from '~interfaces/props';
import ColumnLayout2 from '~modules/columns/ColumnLayout2';
import ColumnLayout3 from '~modules/columns/ColumnLayout3';
import { getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';
import log from '~services/log';

export interface IColumnLayoutProps {
  stable: boolean;
  editing: boolean;
  data: string[];
  parentContext: string;
  parentType: string;
  fieldName: string;
  siblingsLength: number;
  index: number;
  canMove: boolean;
  columnsClasses: string[];
}

export const ModuleColumns = ({ data, editing, index, className, onChange, stable }: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;

  const childModuleIds = getRelatedEntityIds(data, 'field_modules');
  const childModuleIdsLength = childModuleIds.length;
  const numColumns: string = content.field_num_columns;
  const layout = content.field_layout;
  const columnsMap = {
    2: {
      items: 2,
      component: ColumnLayout2,
    },
    3: {
      items: 3,
      component: ColumnLayout3,
    },
  };
  const layoutMap = {
    2: {
      1: ['col col-6', 'col col-6'],
      2: ['col col-8', 'col col-4'],
      3: ['col col-4', 'col col-8'],
    },
    3: ['col col-4', 'col col-4', 'col col-4'],
  };
  const columnsConfig = columnsMap[numColumns];
  let layoutClasses = layoutMap[numColumns];
  if (layout && layoutClasses && !Array.isArray(layoutClasses)) {
    layoutClasses = layoutClasses[layout];
  }
  if (!columnsConfig) {
    log(`No layout configuration found for column layout type ${numColumns}!`, null, 'error');
    return null;
  }
  const ColumnLayout = columnsConfig.component;

  const clsModule = clsx({ ...className.module }, 'relative');
  const clsContainer = clsx({ ...className.container }, 'px-0 relative');
  const clsHeader = clsx('c-module__header row');
  const clsHeaderContent = clsx('col col-12');
  const clsContent = clsx('c-module__content');

  return (
    <div className={clsModule} id={getModuleUrlIdFromData(data.id, data.type)}>
      <div className={clsContainer}>
        <div className={clsHeader}>
          <div className={clsHeaderContent}>
            <EditableField
              hide={content.field_hide_title}
              entityType={data.type}
              fieldName="attributes.field_title.value"
              data={content.field_title.value}
              editing={editing}
              onChange={onChange}
            />
          </div>
          <ModuleAttachments data={data} />
        </div>
        <div className={clsContent}>
          <ColumnLayout
            data={childModuleIds}
            editing={editing}
            parentContext={data.id}
            parentType={data.type}
            fieldName="relationships.field_modules.data"
            siblingsLength={childModuleIdsLength}
            index={index}
            canMove={editing}
            stable={stable}
            columnsClasses={layoutClasses}
          />
        </div>
      </div>
    </div>
  );
};

export default ModuleColumns;
